import {createSlice, PayloadAction} from "@reduxjs/toolkit";

interface SignUpScreenState {
  screen: string,
  history: string[]
}

const initialState:SignUpScreenState = {
  screen: '',
  history: []
}

const signUpScreenSlice = createSlice({
  name: 'signUpScreen',
  initialState,
  reducers: {
    updateSignUpScreen: (state, action: PayloadAction<string>) => {
      state.screen = action.payload;
      // ensure that only 10 screens are saved within history
      if (state.history.length === 10)  state.history.shift();
      else state.history.push(action.payload)
    },
  }
})

export const {updateSignUpScreen} = signUpScreenSlice.actions;

export default signUpScreenSlice.reducer;
